import { useCallback, useEffect, useState } from "react";
import { useService } from "../../../../hooks";
import { searchRegex } from "../../../../constant";

export const useBlogSideBar = () => {
  const { fetchByAttr } = useService("Data", "post");
  const { getProduct } = useService("Product");
  const [recentPost, setrecentPost] = useState([]);
  const [productData, setproductData] = useState([]);
  const [filteredList, setfilteredList] = useState([]);
  const [filteredPostList, setfilteredPostList] = useState([]);
  const [searchPostKey, setsearchPostKey] = useState<string>("");
  const [searchKey, setsearchKey] = useState<string>("");
  const searchProduct = useCallback(
    (e) => {
      if (e.target.value === "" || searchRegex.test(e.target.value)) {
        setsearchKey(e.target.value);
        let tempTitle = "",
          filteredList = [],
          tempSku = "";
        productData.forEach((e) => {
          tempTitle = e.title?.toLowerCase();
          tempSku = e.sku?.toLowerCase();
          if (
            tempSku.search(searchKey.toLowerCase()) !== -1 ||
            tempTitle.search(searchKey.toLowerCase()) !== -1
          ) {
            filteredList.push(e);
          }
        });
        setfilteredList(filteredList);
      }
    },
    [productData, searchKey]
  );

  const searchPost = useCallback(
    (e) => {
      if (e.target.value === "" || searchRegex.test(e.target.value)) {
        setsearchPostKey(e.target.value);
        let tempTitle = "",
          filteredPostList = [];
        recentPost.forEach((e) => {
          tempTitle = e.title.toLowerCase();
          if (tempTitle.search(searchPostKey.toLowerCase()) !== -1) {
            filteredPostList.push(e);
          }
        });
        setfilteredPostList(filteredPostList);
      }
    },
    [recentPost, searchPostKey]
  );
  const getPostsData = useCallback(async () => {
    const result = await fetchByAttr({ status: "publish" });
    if (result.status) {
      setrecentPost(result.data);
      setfilteredPostList(result.data);
    }
  }, [fetchByAttr]);

  const getProductsData = useCallback(async () => {
    const result = await getProduct({ status: "publish" });
    if (result.status) {
      if (result.data?.length !== 0) {
        setfilteredList(result.data);
        setproductData(result.data);
      }
    }
  }, [getProduct]);

  useEffect(() => {
    getPostsData();
    getProductsData();
  }, [getPostsData, getProductsData]);

  return {
    searchProduct,
    searchPost,
    getPostsData,
    recentPost,
    filteredList,
    filteredPostList,
    searchPostKey,
    searchKey,
  };
};
